export const LoadType = {
  EGF: 1,
  DIB: 2,
};
